import axios from "axios";

const httpConfig = {
  baseURL:`${process.env.VUE_APP_BASE_URL}`
};

// const httpObj = axios.create({
//   baseURL: "https://lorder-api.shipwork.net/api",
//   withCredentials: false,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     //Authorization: currentUser && currentUser.token
//   },
// });

/**
 * ex) https://www.shipwork.net/api/userInfoes?auth=ecis7000&username=ktyuzz&emplyrId=ktyuzz
 *
 *      http.get('/user',{emplyrId : ktyuzz})
 *      .then(response => this.users = response.content)
 *      .catch(e => //-- console.log(e););
 */
// var params = new URLSearchParams();
// params.append("clientId", id);
const http = {
  setAuthorization: function(token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  },

  setHeader: function(key, value) {
    axios.defaults.headers.common["key"] = value;
  },
  /**
   * @param {string} urlPath
   * @param {URLSearchParams} params
   * @param {AxiosRequestConfig} config
   */
  get: function(urlPath, params = undefined, config = undefined) {
    // body가 없으므로 params는 QueryString 형태로 전송
    return axios.get(this.resolveBaseURL(urlPath, params), config);
  },

  /**
   * @param {string} urlPath
   * @param {URLSearchParams} params
   * @param {AxiosRequestConfig} config
   */
  getBlob: function(urlPath, params = undefined, config = undefined) {
    // body가 없으므로 params는 QueryString 형태로 전송
    axios.responseType = "blob";
    return axios.get(this.resolveBaseURL(urlPath, params), config);
  },

  /**
   * @param {string} urlPath
   * @param {URLSearchParams} params
   * @param {AxiosRequestConfig} config
   */
  post: function(urlPath, params = undefined, config = undefined) {
    // body를 사용하므로 params는  body에 담겨 전송
    return axios.post(this.resolveBaseURL(urlPath), params, config);
  },

  /**
   * @param {string} urlPath
   * @param {URLSearchParams} params
   * @param {AxiosRequestConfig} config
   * @param {Progress} progress
   */
  postProgress: function(urlPath, params = undefined, progress = undefined) {
    // body를 사용하므로 params는  body에 담겨 전송
    return axios.post(this.resolveBaseURL(urlPath), params, progress);
  },

  /**
   * @param {string} urlPath
   * @param {URLSearchParams} params
   * @param {AxiosRequestConfig} config
   */
  patch: function(urlPath, params = undefined, config = undefined) {
    // body를 사용하므로 params는  body에 담겨 전송
    return axios.patch(this.resolveBaseURL(urlPath), params, config);
  },
  /**
   * @param {string} urlPath
   * @param {URLSearchParams} params
   * @param {AxiosRequestConfig} config
   */
  delete: function(urlPath, params = undefined, config = undefined) {
    // body를 사용하지 않으므로 QueryString형태로 전송
    return axios.delete(this.resolveBaseURL(urlPath, params), config);
  },
  /**
   * 최종 요청할 URL 주소를 만들어줌.
   * @param {string} urlPath
   */
  resolveBaseURL: function(urlPath, params = undefined) {
    // https 또는 http 로 시작하는 요청의 경우, 파라미터 그대로 사용함. 그외엔 baseURL을 사용함.
    let queryString = params
      ? (urlPath.indexOf("?") > -1 ? "&" : "?") + params.toString()
      : "";
    const result =
      urlPath &&
      (urlPath.startsWith("http://") || urlPath.startsWith("https://"))
        ? `${urlPath}${queryString}`
        : `${httpConfig.baseURL}${urlPath}${queryString}`;

    return result;
  },
};
export { http as default };

/**
 axios.all([getToken(), getUserConfig()]).then(
 axios.spread(function(acct, perms) {
 // Both requests are now complete
 })
 );
 */
